module.exports = __webpack_public_path__ + "static/media/avatarMed.4407d956.svg";